import React from "react";
import styled from "styled-components";
import { Modal } from "react-bootstrap";

export const DialogBody = styled(Modal.Body)`
    min-height: 66.67vh;
    max-height: 66.67vh;
    display: flex;
    flex-direction: column;
    padding: 0;
`;